import jsPDF from 'jspdf';
import {OrderInfo} from '../types/TypesUserOrders';
import logo from '../assets/img/clogo5.png';
import {toast} from 'react-toastify';

export const generateOrderPDF = async (orderData: OrderInfo) => {
	try {
		// Отладочная информация
		console.log('Order data for PDF:', {
			id: orderData.id,
			points: orderData.points,
			money: orderData.money,
			pay_money: orderData.pay_money,
			bonus: orderData.bonus,
			products: orderData.products?.length
		});

		// Создаем PDF
		const pdf = new jsPDF({
			orientation: 'portrait',
			unit: 'mm',
			format: 'a4',
		});

		const pageWidth = pdf.internal.pageSize.getWidth();
		const pageHeight = pdf.internal.pageSize.getHeight();
		const margin = 20; // Отступы со всех сторон
		const contentWidth = pageWidth - 2 * margin;
		const maxContentHeight = pageHeight - 2 * margin;

		// Функция для добавления header на каждую страницу
		const addHeader = (pdf: jsPDF, pageNumber: number) => {
			// Логотип
			try {
				// Добавляем логотип напрямую
				pdf.addImage(logo, 'PNG', margin, margin, 30, 10);
			} catch (e) {
				// Если логотип не загрузился, продолжаем без него
				console.warn('Logo not loaded:', e);
			}

			// Заголовок заказа
			pdf.setFontSize(14);
			pdf.setFont('helvetica', 'bold');
			pdf.text(
				`ЗАМОВЛЕННЯ № ${orderData.id} ВІД ${orderData.create_date?.split('T')[0] || ''}`,
				margin,
				margin + 20
			);
		};

		// Функция для добавления footer на каждую страницу
		const addFooter = (pdf: jsPDF, pageNumber: number, totalPages: number) => {
			const footerY = pageHeight - margin;
			pdf.setFontSize(8);
			pdf.setFont('helvetica', 'normal');
			pdf.setTextColor(100, 100, 100);
			pdf.text(
				`Сторінка ${pageNumber} з ${totalPages}`,
				pageWidth / 2,
				footerY,
				{ align: 'center' }
			);
			pdf.text(
				`© Choice - Система управління замовленнями`,
				pageWidth / 2,
				footerY + 5,
				{ align: 'center' }
			);
			pdf.text(
				`Дата генерації: ${new Date().toLocaleDateString('uk-UA')}`,
				pageWidth / 2,
				footerY + 10,
				{ align: 'center' }
			);
			pdf.setTextColor(0, 0, 0);
		};

		// Начальная позиция для контента
		let currentY = margin + 35; // После header
		const headerHeight = 35;
		const footerHeight = 20;
		const availableHeight = pageHeight - margin - headerHeight - footerHeight;

		// Добавляем первую страницу с header
		addHeader(pdf, 1);
		let currentPage = 1;

		// Таблица товаров
		if (orderData.products && orderData.products.length > 0) {
			const rowHeight = 8; // Высота строки таблицы
			const headerRowHeight = 10; // Высота заголовка таблицы
			const startY = currentY;

			// Заголовки таблицы
			pdf.setFontSize(9);
			pdf.setFont('helvetica', 'bold');
			pdf.setFillColor(51, 51, 51);
			pdf.setTextColor(255, 255, 255);
			
			// Проверяем, помещается ли заголовок
			if (currentY + headerRowHeight > pageHeight - footerHeight - margin) {
				pdf.addPage();
				currentPage++;
				addHeader(pdf, currentPage);
				currentY = margin + headerHeight;
			}

			// Рисуем заголовок таблицы
			pdf.rect(margin, currentY, contentWidth, headerRowHeight, 'F');
			pdf.text('№', margin + 2, currentY + 7);
			pdf.text('Назва', margin + 10, currentY + 7);
			pdf.text('Кільк', margin + 60, currentY + 7);
			pdf.text('Ціна,бали', margin + 75, currentY + 7);
			pdf.text('Ціна,грн', margin + 95, currentY + 7);
			pdf.text('Сума,бали', margin + 115, currentY + 7);
			pdf.text('Сума,грн', margin + 135, currentY + 7);

			currentY += headerRowHeight;
			pdf.setTextColor(0, 0, 0);

			// Строки товаров
			pdf.setFontSize(8);
			pdf.setFont('helvetica', 'normal');

			orderData.products.forEach((product, index) => {
				// Проверяем, нужна ли новая страница
				if (currentY + rowHeight > pageHeight - footerHeight - margin) {
					// Добавляем footer на текущую страницу
					addFooter(pdf, currentPage, 0); // 0 = временно, обновим позже
					
					// Создаем новую страницу
					pdf.addPage();
					currentPage++;
					addHeader(pdf, currentPage);
					
					// Перерисовываем заголовок таблицы на новой странице
					currentY = margin + headerHeight;
					pdf.setFontSize(9);
					pdf.setFont('helvetica', 'bold');
					pdf.setFillColor(51, 51, 51);
					pdf.setTextColor(255, 255, 255);
					pdf.rect(margin, currentY, contentWidth, headerRowHeight, 'F');
					pdf.text('№', margin + 2, currentY + 7);
					pdf.text('Назва', margin + 10, currentY + 7);
					pdf.text('Кільк', margin + 60, currentY + 7);
					pdf.text('Ціна,бали', margin + 75, currentY + 7);
					pdf.text('Ціна,грн', margin + 95, currentY + 7);
					pdf.text('Сума,бали', margin + 115, currentY + 7);
					pdf.text('Сума,грн', margin + 135, currentY + 7);
					currentY += headerRowHeight;
					pdf.setTextColor(0, 0, 0);
					pdf.setFontSize(8);
					pdf.setFont('helvetica', 'normal');
				}

				// Чередующийся цвет фона
				if (index % 2 === 0) {
					pdf.setFillColor(248, 249, 250);
					pdf.rect(margin, currentY, contentWidth, rowHeight, 'F');
				}

				// Рисуем границы ячеек
				pdf.setDrawColor(221, 221, 221);
				pdf.rect(margin, currentY, contentWidth, rowHeight, 'S');

				// Данные товара
				pdf.text(String(index + 1), margin + 2, currentY + 6);
				
				// Название товара (может быть длинным, обрезаем)
				const productName = product.name || '';
				const maxNameWidth = 45;
				let displayName = productName;
				if (pdf.getTextWidth(displayName) > maxNameWidth) {
					// Обрезаем название, если слишком длинное
					while (pdf.getTextWidth(displayName + '...') > maxNameWidth && displayName.length > 0) {
						displayName = displayName.slice(0, -1);
					}
					displayName += '...';
				}
				pdf.text(displayName, margin + 10, currentY + 6);
				
				pdf.text(String(product.count || 0), margin + 60, currentY + 6);
				pdf.text(String(product.points || 0), margin + 75, currentY + 6);
				pdf.text(`${product.money || 0} грн`, margin + 95, currentY + 6);
				pdf.text(String((product.count || 0) * (product.points || 0)), margin + 115, currentY + 6);
				pdf.text(`${(product.count || 0) * (product.money || 0)} грн`, margin + 135, currentY + 6);

				currentY += rowHeight;
			});
		} else {
			// Нет товаров
			pdf.setFontSize(10);
			pdf.setFont('helvetica', 'normal');
			pdf.text('Немає товарів', margin, currentY);
			currentY += 10;
		}

		// Итоги (на последней странице)
		// Проверяем, помещается ли блок итогов
		if (currentY + 40 > pageHeight - footerHeight - margin) {
			addFooter(pdf, currentPage, 0);
			pdf.addPage();
			currentPage++;
			addHeader(pdf, currentPage);
			currentY = margin + headerHeight;
		}

		pdf.setFontSize(10);
		pdf.setFont('helvetica', 'normal');
		currentY += 10;

		// Сумма баллов и денег
		pdf.text(
			`Сума балів та сума грн по всім товарам: ${orderData.points || 0} б., ${orderData.money || 0} грн.`,
			margin,
			currentY
		);
		currentY += 8;

		// Скидка (если есть)
		if (orderData.bonus) {
			pdf.text(`Знижка: ${orderData.bonus} грн`, margin, currentY);
			currentY += 8;
		}

		// Сумма к оплате
		pdf.setFont('helvetica', 'bold');
		pdf.text(
			`Сума до сплати: ${orderData.pay_money || orderData.money || 0} грн`,
			margin,
			currentY
		);

		// Добавляем footer на все страницы
		const totalPages = currentPage;
		for (let i = 1; i <= totalPages; i++) {
			pdf.setPage(i);
			addFooter(pdf, i, totalPages);
		}

		// Открываем PDF в новой вкладке
		const pdfBlob = pdf.output('blob');
		const pdfUrl = URL.createObjectURL(pdfBlob);
		window.open(pdfUrl, '_blank');

		// Очищаем URL через некоторое время
		setTimeout(() => {
			URL.revokeObjectURL(pdfUrl);
		}, 10000);

	} catch (error) {
		console.error('Ошибка генерации PDF:', error);
		toast.error('Помилка при генерації PDF. Спробуйте ще раз.');
		throw error;
	}
};
